import { Icon, IconButton } from '@assembly-js/design-system';
import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

export const ActionMenu = ({ onDelete }: { onDelete: () => void }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        icon="Ellipsis"
        label="More actions"
        variant="minimal"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className="hover:cursor-pointer hover:bg-gray-100 w-7 h-7 p-0 inline-flex items-center justify-center [&>*]:w-4 [&>*]:h-4"
      />
      <Menu
        open={anchorEl !== null}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={() => setAnchorEl(null)}
        classes={{
          paper:
            'border border-solid border-secondary-hover shadow-dropdown-menu',
        }}
      >
        <MenuItem onClick={onDelete}>
          <ListItemIcon classes={{ root: '!min-w-8' }}>
            <Icon icon="Trash" className="w-4 h-4 text-[#991A00]" />
          </ListItemIcon>
          <ListItemText classes={{ primary: 'text-[#991A00]' }}>
            Delete note
          </ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
